<template>
  <modal
    :name="'countdown-continue-modal-' + index"
    :adaptive="true"
    height="auto"
    :scrollable="true"
  >
    <div class="countdown-continue-modal">
      <div v-if="!extended">
        <h2>Your reservation will expire in {{ seconds }} seconds</h2>
        <p>
          Click the button below to extend your reservation.<br />
          Otherwise, your reservation will expire.
        </p>

        <button
          @click.prevent="extendReservation"
          class="btn btn--quaternary"
          :disabled="form.busy"
        >
          {{ form.busy ? "Please wait..." : "Extend reservation" }}
        </button>
      </div>

      <div v-else>
        <h2>Your reservation has been extended for another 10 mins.</h2>

        <p>Refreshing in {{ secondsToRefresh }} seconds.</p>
      </div>
    </div>
  </modal>
</template>

<script>
import { Form } from "vform";
export default {
  name: "countdown-continue-modal",
  props: {
    seconds: {
      required: true,
      type: Number,
    },
    index: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      form: new Form(),
      extended: false,
      secondsToRefresh: 3,
    };
  },
  methods: {
    extendReservation() {
      this.form.post("/checkout/extend-reservation").then((response) => {
        this.extended = true;
        setInterval(() => {
          this.secondsToRefresh--;

          if (this.secondsToRefresh == 0) {
            window.location.reload();
          }
        }, 1000);
      });
    },
  },
};
</script>

<style scoped>
.countdown-continue-modal {
  padding: 40px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/modals/countdown-continue-modal.vue